import
{
    Autocomplete, Box, Checkbox, RadioGroup,
    Radio, FormControlLabel, Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import TextField from '@mui/material/TextField';
import { useState, Downgraded } from '@hookstate/core';
import Helper from '../../utility/helper';
import Title from '../../sharedcomponents/title/title';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip';
//import { ScheduleDataService } from '../../services/ScheduleService';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const EditAllParticipant = (props) =>
{
    const tags = useState(null);
    const roles = useState(null);
    const selectedTags = useState([]);
    const userRole = useState(null);
    const originalSelectedTags = useState([]);
    const userInfo = useState(null);
    const loading = useState(false);
    const [check, setCheck] = React.useState(false);
    const [createdBy, setCreatedBy] = React.useState(0);
    const [disableBtn, setDisableBtn] = React.useState(true);
    useEffect(() => {
        const fetchData = async () => {
          try {
            const eventInfo = Helper.getStorage('eventInfo');
            const userdetail = Helper.getStorage('userInfo');
            setCreatedBy(userdetail.userID);
            await setRolesNTags(eventInfo.eventID);
            await setRoles(eventInfo.eventID);
            if (
              props.eventUserInfo &&
              userInfo.get() == null &&
              tags.get() != null
            ) {
              const eventUserInfo = props.eventUserInfo;
              userInfo.set(eventUserInfo);
              const getTags = tags
                .attach(Downgraded)
                .get()
                .filter((item) =>
                  eventUserInfo.userTags
                    ? eventUserInfo.userTags.split(', ').includes(item.tagName)
                    : false
                );
              selectedTags.set(getTags);
              originalSelectedTags.set(getTags);
            }
          } catch (error) {
            console.error('Error in useEffect:', error);
          }
        };
      
        fetchData();
      }, []);
      
    const setRolesNTags = async (eventID) =>
    {
        const tagsdata = ApiHelper.get(APIURLConstants.GET_TAGS(eventID));
        await Promise.all([tagsdata]).then((data) =>
        {
            Helper.setStorage('userTags', data[0].data);
            const tagsd = data[0].data.filter((item) => item.status == 1);
            tags.set(tagsd);
        });
    };

    const setRoles = async (eventID) =>
    {
        const rolesdata = ApiHelper.get(APIURLConstants.GET_ROLES(eventID));
        await Promise.all([rolesdata]).then((data) =>
        {
            Helper.setStorage('userRoles', data[0].data);
            const rolesd = data[0].data.filter((item) => item.status == 1);
            roles.set(rolesd);
        });
    };

    React.useEffect(() =>
    {
        handleDisableBtn()
    }, [check])
    const renderDialogContent = () =>
    {
        return (
            <>
                {userInfo.get() ? (
                    <>
                    <Box
                    sx={{
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center',
                        justifyContent:'center',
                        flexWrap:'wrap',
                        width:'100%'
                    }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={15}
                        fontWeight={700}
                        fontFamily={'Lato'}
                        noWrap 
                        fontStyle="normal" 
                        color='primary'
                        component="div" 
                        sx={{
                            ml: 0,
                            textOverflow:'unset',
                            overflow:'unset',
                            whiteSpace:'normal'
                        }}
                    >
                        User : {userInfo.get() &&
                                userInfo.get().length > 0 &&
                                userInfo.get().map((key,i) =>
                                {
                                    return <Chip key={i} sx={{ mr: '4px', mb: '2px',fontSize:'10px',height:'25px' }} label={key.actualData.name} />;
                                })
                                }
                    </Typography>
                    </Box>
                        {/* <Title
                            title={`User : ${userInfo.get() &&
                                userInfo.get().length > 0 &&
                                userInfo.get().map((key) =>
                                {
                                    return key.actualData.name;
                                })
                                }`}
                            sx={{
                                ml: 0,
                            }}
                            px={0}
                        /> */}
                        {props.EditTages ?(
                        <Box>
                             <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={15}
                                fontWeight={700}
                                fontFamily={'Lato'}
                                noWrap
                                fontStyle="normal"
                         
                                color='primary'
                                component="div"
                                sx={{
                                    ml: 0,
                                    pt: 2,
                                    pb: 1,
                                }}
                            >Overwrite Tags : <Checkbox
                            inputProps={{
                                'aria-label': 'overwrite',
                            }}
                            checked={check}
                            onChange={() => { setCheck(check => !check); handleDisableBtn() }}
                            // color="secondary"
                            disabled={false}
                            sx={{ marginLeft: 0 }}
                        /></Typography>
                            {/* <Title
                                title="Overwrite Tags :"
                                sx={{
                                    ml: 0,
                                    pt: 2,
                                    pb: 1,
                                }}
                                px={0}
                            /> */}
                            
                        </Box>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={15}
                            fontWeight={700}
                            fontFamily={'Lato'}
                            noWrap
                            fontStyle="normal"
                            color='primary'
                            component="div"
                            sx={{
                                ml: 0,
                                pt: 1,
                                pb: 1,
                            }}
                        >Add Tags :</Typography>
                        {/* <Title
                            title="Add Tags"
                            sx={{
                                ml: 0,
                                pt: 1,
                                pb: 1,
                            }}
                            px={0}
                        /> */}
                        {tags.get() ? (
                            <Autocomplete
                                multiple
                                id="size-small-standard-multi"
                                size="small"
                                options={tags.attach(Downgraded).get()}
                                getOptionLabel={(option) => option.tagName}
                                value={selectedTags.attach(Downgraded).get()}
                                onChange={(event, newValue) =>
                                {
                                    selectedTags.set(newValue);
                                    handleDisableBtn();
                                }}
                                // defaultValue={[top100Films[1]]}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder="Tags" />
                                )}
                            />
                        ) : null}
                        </Box>
                        ):null}
                       { props.EditRoles ? ( 
                       <Box>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={15}
                            fontWeight={700}
                            fontFamily={'Lato'}
                            noWrap
                            fontStyle="normal"
                            color='primary'
                            component="div"
                            sx={{
                                ml: 0,
                                pt: 1,
                                pb: 1,
                            }}
                        >Add Roles :</Typography>
                        {/* <Title
                            title="Add Roles"
                            sx={{
                                ml: 0,
                                pt: 1,
                                pb: 1,
                            }}
                            px={0}
                        /> */}
                        {/* {roles.get() ? (
                            <Autocomplete
                                id="size-small-standard-single"
                                size="small"
                                options={roles.attach(Downgraded).get()}
                                getOptionLabel={(option) => option.roleName}
                                value={selectedRoles.attach(Downgraded).get()}
                                onChange={(event, newValue) => {
                                    selectedRoles.set(newValue);
                                }}
                                // defaultValue={[top100Films[1]]}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder="Roles" />
                                )}
                            />
                        ) : null} */}


                        {roles.get() && roles.get().length > 0 ? (
                            <RadioGroup
                                row
                                aria-label="tripType"
                                name="userRole"
                                value={userRole.get()}
                                onChange={(event) =>
                                {
                                    userRole.set(event.target.value);
                                    handleDisableBtn();
                                }
                                }>
                                {roles
                                    .attach(Downgraded)
                                    .get()
                                    .map((item, index) =>
                                    {
                                        return (
                                            <FormControlLabel
                                                key={`roles_${index}`}
                                                value={item.roleID}
                                                control={
                                                    <Radio
                                                        color="primary"
                                                        size="small"
                                                    />
                                                }
                                                label={item.roleName}
                                            />
                                        );
                                    })}
                            </RadioGroup>
                        ) : null}
                 </Box>
                 ):null }
                    </>
                ) : (
                    <Box style={loader}>
                        <CircularProgress />
                    </Box>
                )}
            </>
        );
    };

    const handleDisableBtn = () =>
    {
        let prevData = {
            overwrite: false,
            userTags: '',
            userRoles: null
        }
        const setUserTags = selectedTags.attach(Downgraded).get();
        const setUserTagsList =
            setUserTags.length > 0
                ? setUserTags.map((tag) => tag.tagID).join(',')
                : '';
        let currentData = {
            overwrite: check,
            userTags: setUserTagsList,
            userRoles: userRole.get()
        }
        if (JSON.stringify(prevData) === JSON.stringify(currentData))
        {
            setDisableBtn(true)
        } else
        {
            setDisableBtn(false)
        }
    }

    // const handleClick = () =>
    // {
    //     loading.set(true);
    //     const setUserTags = selectedTags.attach(Downgraded).get();
    //     if (setUserTags.length <= 0 && !props.EditRoles)
    //     {
    //         props.setSnackBarProps({
    //             ...props.snackBarProps,
    //             openSnack: true,
    //             variant: 'error',
    //             message: 'Please select tag',
    //         });
    //         loading.set(false);
    //         return;
    //     }
    //     const setUserTagsList =
    //         setUserTags.length > 0
    //             ? setUserTags.map((tag) => tag.tagID).join(',')
    //             : '';
    //     //const setUserRoles = selectedRoles.attach(Downgraded).get();
    //     if (userRole.get() == null && !props.EditTages)
    //     {
    //         props.setSnackBarProps({
    //             ...props.snackBarProps,
    //             openSnack: true,
    //             variant: 'error',
    //             message: 'Please select role',
    //         });
    //         loading.set(false);
    //         return;
    //     }
    //     // const setUserRolesList =
    //     //     setUserRoles.length > 0
    //     //         ? setUserRoles.map((tag) => tag.roleID).join(',')
    //     //         : '';
    //     const userList =
    //         userInfo.get().length > 0
    //             ? userInfo
    //                 .get()
    //                 .map((key) => key.actualData.eventUsersID)
    //                 .join(',')
    //             : '';

    //     let requestObj = {
    //         eventUsersID: userList,
    //         overwrite: check,
    //         createdBy: createdBy,
    //         userTags: setUserTagsList,
    //         userRoles: userRole.get()
    //     };

    //     ApiHelper.post(
    //         APIURLConstants.POST_EDIT_EVENT_PARTICIPANT_ROW,
    //         requestObj
    //     )
    //         .then((res) =>
    //         {
    //             if (res.data)
    //             {
    //                 props.setSnackBarProps({
    //                     ...props.snackBarProps,
    //                     openSnack: true,
    //                     variant: 'success',
    //                     message: 'Participant updated successfully',
    //                 });
    //                 props.handleClose();
    //                 props.getParticipants();
    //             }
    //             //}
    //         })
    //         .catch((error) =>
    //         {
    //             console.log('error : ', error);
    //             let message = '';
    //             if (error.response && error.response.status === 401)
    //             {
    //                 message = 'Access denied';
    //             } else
    //             {
    //                 message = 'Error while updating participant';
    //             }
    //             props.setSnackBarProps({
    //                 ...props.snackBarProps,
    //                 openSnack: true,
    //                 variant: 'error',
    //                 message: message,
    //             });
    //             // props.handleClose();
    //             // props.getParticipants();
    //         });
    // };
    const handleTagsClick = () =>
    {
        loading.set(true);
        const setUserTags = selectedTags.attach(Downgraded).get();
        if (setUserTags.length <= 0 && !props.EditRoles)
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select tag',
            });
            loading.set(false);
            return;
        }
        const setUserTagsList =
            setUserTags.length > 0
                ? setUserTags.map((tag) => tag.tagID).join(',')
                : '';
        //const setUserRoles = selectedRoles.attach(Downgraded).get();
        // const setUserRolesList =
        //     setUserRoles.length > 0
        //         ? setUserRoles.map((tag) => tag.roleID).join(',')
        //         : '';
        const userList =
            userInfo.get().length > 0
                ? userInfo
                    .get()
                    .map((key) => key.actualData.eventUsersID)
                    .join(',')
                : '';

        let requestObj = {
            eventUsersID: userList,
            overwrite: check,
            createdBy: createdBy,
            userTags: setUserTagsList,
            userRoles: userRole.get()
        };

        ApiHelper.post(
            APIURLConstants.POST_EDIT_EVENT_PARTICIPANT_ROW,
            requestObj
        )
            .then((res) =>
            {
                if (res.data)
                {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Participant updated successfully',
                    });
                    props.handleClose();
                    props.getParticipants();
                }
                //}
            })
            .catch((error) =>
            {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while updating participant';
                }
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
                // props.handleClose();
                // props.getParticipants();
            });
    };
    const handleRolesClick = () =>
    {
        loading.set(true);
        const setUserTags = selectedTags.attach(Downgraded).get();
        const setUserTagsList =
            setUserTags.length > 0
                ? setUserTags.map((tag) => tag.tagID).join(',')
                : '';
        //const setUserRoles = selectedRoles.attach(Downgraded).get();
        if (userRole.get() == null && !props.EditTages)
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select role',
            });
            loading.set(false);
            return;
        }
        // const setUserRolesList =
        //     setUserRoles.length > 0
        //         ? setUserRoles.map((tag) => tag.roleID).join(',')
        //         : '';
        const userList =
            userInfo.get().length > 0
                ? userInfo
                    .get()
                    .map((key) => key.actualData.eventUsersID)
                    .join(',')
                : '';

        let requestObj = {
            eventUsersID: userList,
            overwrite: check,
            createdBy: createdBy,
            userTags: setUserTagsList,
            userRoles: userRole.get()
        };

        ApiHelper.post(
            APIURLConstants.POST_EDIT_EVENT_PARTICIPANT_ROW,
            requestObj
        )
            .then((res) =>
            {
                if (res.data)
                {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Participant updated successfully',
                    });
                    props.handleClose();
                    props.getParticipants();
                }
                //}
            })
            .catch((error) =>
            {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while updating participant';
                }
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
                // props.handleClose();
                // props.getParticipants();
            });
    };

    const renderDialogActions = () =>
    {
        return (
            <ButtonContainer
                showLoading={true}
                loading={loading.get()}
                handleClick={props.EditTages ? handleTagsClick : handleRolesClick}
                handleCancel={props.handleClose}
                buttonText={'Update'}
                disableUpdateButton={disableBtn}
            />
        );
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default EditAllParticipant;
